import React, { createContext, useContext } from 'react';
import { useOnlineStatus, type SyncStatus } from '@/hooks/useOnlineStatus';

interface OnlineStatusContextValue {
  isOnline: boolean;
  isSyncing: boolean;
  syncStatus: SyncStatus;
  pendingChanges: number;
  lastSyncTime: number | null;
  triggerSync: () => Promise<void>;
  wasOffline: boolean;
}

const OnlineStatusContext = createContext<OnlineStatusContextValue>({
  isOnline: true,
  isSyncing: false,
  syncStatus: 'idle',
  pendingChanges: 0,
  lastSyncTime: null,
  triggerSync: async () => {},
  wasOffline: false,
});

export const OnlineStatusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const onlineStatus = useOnlineStatus();
  return (
    <OnlineStatusContext.Provider value={onlineStatus}>
      {children}
    </OnlineStatusContext.Provider>
  );
};

export const useOnlineStatusContext = (): OnlineStatusContextValue => {
  return useContext(OnlineStatusContext);
};